import styled, { css } from 'styled-components';

export const MotorSportRowWrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.1em;
  min-height: 4em;
  width: 100%;
  padding: 0.5em 0;
  margin: ${props => (props.isHighlight ? '0px' : '0 auto 0.4em')};
  border-left-width: ${props => (props.isHighlight ? '0px' : '1px')};
  border-right-width: ${props => (props.isHighlight ? '0px' : '1px')};
  border-top-width: 1px;
  border-bottom-width: ${props => (props.isHighlight ? '0px' : '1px')};
  border-color: ${props => props.theme.colors.mediumDarkGray};
  border-style: solid;
  
  &:hover {
    background: ${props => (props.href ? props.theme.colors.hoverColor : '')};
    border-color: ${props => (props.href ? props.theme.colors.hoverBorderColor : '')};
  };
  ${props => (!props.href ? 'pointer-events: none' : '')}
`;

export const RaceViewCircuit = styled.div`
  display: flex;
  justify-content: center;
`;

export const Circuit = styled.img`
  height: ${props => (props.isMatchPage ? '85px' : '30px')};
  image-rendering: optimizeSpeed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  -ms-interpolation-mode: nearest-neighbor;
  filter:invert(100%);
  ${props => props.width && css`
    width: ${props.justifyContent};
    height: auto;
  `};
  ${props => props.isPlayer && css`
    height: 34px;
    width: 34px;
  `};
  ${props => props.isForma && css`
    height: 45px;
  `};
  ${props => props.isFlag && css`
    height: 20px;
    width: 30px;
    margin: 0px 5px 0px 5px
  `};
  ${props => props.isHeader && css`
    ${props.theme.mediaQueries.phone}{
      height: 60px;
    };
  `};
  ${props => props.gpFlag && css`
    height: 50px;
    width: 70px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/MotorSportRow/styles.js